import { AuthService } from "@/modules/Login/services/AuthService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "SpecialistSignature"
})
export default class SpecialistSignature extends Vue {
  @Inject() authService!: AuthService;

  signatureForm = false;
  inputUser = "";
  inputPassword = "";
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;

  cancel() {
    this.$emit("cancel");
  }

  async accept() {
    if (!this.signatureForm) return;

    const response = await this.authService.specialistSignature(
      this.inputUser,
      this.inputPassword
    );
    console.log("response", response);
    if (response.code == Http.Ok) {
      console.log("response", response.data);
      Snackbar.popSuccess(response.message);
      this.$emit("accept", response.data);
      return;
    }
    Snackbar.popError(response.message);
    this.$emit("accept", "");
  }
}
